import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import FormField from "components/molecules/FormField/FormField";
import { ICountries } from "pages/shipper/RequestForm/components/Schedule/Types";
import PickupDeliveryDate from "pages/shipper/RequestForm/components/Schedule/PickupDeliveryDate";
import PortInfo from "./PortInfo";

interface OceanFreightProps {
  countries: ICountries[];
}

function OceanFreightDelivery(props: OceanFreightProps) {
  const { countries } = props;
  const intl = useIntl();

  const [holidays, setHolidays] = useState({});

  return (
    <>
      <div>
        <div className="flex-row mb-3">
          <div className="w-192">
            <FormField
              validations={{
                shouldUnregister: true,
              }}
              id="id_pickup_contact_email"
              label={intl.formatMessage({
                id: "quote.provider.vesselNumber",
                defaultMessage: "Vessel number / IMO",
              })}
              type="textinput"
              field_id="schedule.vessel_number"
            />
          </div>
          <div className="w-192 align-date">
            <label>
              <FormattedMessage id="quote.provider.vesselDepartureDate" defaultMessage="Vessel departure date" />
            </label>
            <PickupDeliveryDate
              datePickerProps={{
                name: "schedule.vessel_departure_date",
                shouldUnregister: true,
              }}
              countries={countries}
              holidays={holidays}
              setHolidays={setHolidays}
            />
          </div>
        </div>
      </div>
      <PortInfo prefix="departure" countries={countries} />

      <div className="flex-row mt-3 mb-3">
        <div className="w-192 align-date">
          <label>
            <FormattedMessage id="quote.provider.vesselArrivalDate" defaultMessage="Vessel arrival date" />
          </label>
          <PickupDeliveryDate
            datePickerProps={{
              name: "schedule.vessel_arrival_date",
              shouldUnregister: true,
            }}
            countries={countries}
            holidays={holidays}
            setHolidays={setHolidays}
          />
        </div>
      </div>
      <PortInfo prefix="arrival" countries={countries} />
    </>
  );
}

export default OceanFreightDelivery;
